"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Order_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAirportTransfer = exports.getChildSeatsForOrder = exports.Order = exports.OrderPriceCalculationValidationOptions = exports.OrderValidationGroup = void 0;
const constants_1 = require("@daytrip/constants");
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const graphql_1 = require("../graphql");
const orm_1 = require("../orm");
const statusGetter_1 = require("../statusGetter");
const transformToDate_1 = require("../transformers/transformToDate");
const AffiliateConversion_1 = require("./AffiliateConversion");
const DynamicPricingInputs_1 = require("./DynamicPricingInputs");
const Location_1 = require("./Location");
const OrderAutomaticEmail_1 = require("./OrderAutomaticEmail");
const OrderCommission_1 = require("./OrderCommission");
const OrderContentLocation_1 = require("./OrderContentLocation");
const OrderCustomLocation_1 = require("./OrderCustomLocation");
const Passenger_1 = require("./Passenger");
const Position_1 = require("./Position");
const RequestHeader_1 = require("./RequestHeader");
const TravelEstimates_1 = require("./TravelEstimates");
const VehicleTypeCoefficient_1 = require("./VehicleTypeCoefficient");
const VehicleTypePriceFee_1 = require("./VehicleTypePriceFee");
var OrderValidationGroup;
(function (OrderValidationGroup) {
    // Anonymous = "Anonymous",
    OrderValidationGroup["PriceCalculation"] = "PriceCalculation";
    OrderValidationGroup["BookingOrder"] = "BookingOrder";
})(OrderValidationGroup || (exports.OrderValidationGroup = OrderValidationGroup = {}));
exports.OrderPriceCalculationValidationOptions = {
    skipMissingProperties: true,
    groups: [OrderValidationGroup.PriceCalculation],
};
let Order = Order_1 = class Order extends orm_1.CDBaseEntity {
    constructor() {
        super(...arguments);
        this._id = (0, uuid_1.v4)();
        this.createdAt = new Date();
        this.departureAt = (() => {
            const date = new Date();
            date.setUTCHours(9, 0, 0, 0);
            return date;
        })();
        // TODO @MaxLength
        this.pickupAddress = "";
        // TODO @MaxLength
        this.dropoffAddress = "";
        this.passengers = [];
        this.vehicles = [];
        this.currency = legacy_enums_1.Currency.Euro;
        this.currencyRate = 1;
        this.pricingCurrency = legacy_enums_1.Currency.Euro;
        this.customerNote = "";
        this.managementNote = "";
        this.driverNote = "";
        this.customQuoteId = "";
        this.automaticEmails = [];
        this.paymentMethod = legacy_enums_1.PaymentMethod.Cash;
        this.type = legacy_enums_1.OrderType.Private;
        this.tollPrice = 0;
        this.tollFee = 0;
        this.additionalPrice = 0;
        this.additionalFee = 0;
        this.discountCode = ""; // whatever the customer filled out; if accepted, discountId will be in discountIds
        this.discountIds = [];
        this.referralCode = ""; // whatever the customer filled out; if accepted, referralCodeId will be set
        this.vehicleTypesPricesFees = [];
        this.vehicleCoefficients = [];
        this.priceType = legacy_enums_1.PricingType.Flexible;
        this.contentLocations = [];
        this.customLocations = [];
        this.isPickupAddressApproved = false;
        this.isDropoffAddressApproved = false;
        this.isPickupAddressApprovedAutomatically = false;
        this.isDropoffAddressApprovedAutomatically = false;
        this.version = 0;
        this.potentialFraud = false;
        this.isVIP = false;
    }
    get leadPassenger() {
        let leadPassenger = this.passengers.find((p) => p.isLead());
        if (!leadPassenger) {
            leadPassenger = this.passengers.find((p) => p.isAdult());
        }
        return leadPassenger;
    }
    get status() {
        return (0, statusGetter_1.statusGetter)(this, Order_1, legacy_enums_1.OrderStatus);
    }
    static statusPrototype(status) {
        const now = new Date();
        switch (status) {
            case legacy_enums_1.OrderStatus.Cancelled:
                return {
                    cancelledAt: now,
                };
            case legacy_enums_1.OrderStatus.Declined:
                return {
                    cancelledAt: undefined,
                    declinedAt: now,
                };
            case legacy_enums_1.OrderStatus.Draft: {
                return {
                    cancelledAt: undefined,
                    declinedAt: undefined,
                    acceptedAt: undefined,
                    confirmedAt: undefined,
                    draftedAt: now,
                };
            }
            case legacy_enums_1.OrderStatus.Accepted:
                return {
                    cancelledAt: undefined,
                    declinedAt: undefined,
                    acceptedAt: now,
                    confirmedAt: undefined,
                };
            case legacy_enums_1.OrderStatus.Confirmed:
                return {
                    cancelledAt: undefined,
                    declinedAt: undefined,
                    acceptedAt: now,
                    confirmedAt: now,
                };
            case legacy_enums_1.OrderStatus.Pending:
            default:
                return {
                    cancelledAt: undefined,
                    declinedAt: undefined,
                    acceptedAt: undefined,
                    confirmedAt: undefined,
                    draftedAt: undefined,
                };
        }
    }
    isCanceled() {
        return !!this.cancelledAt;
    }
    get confirmationCode() {
        return this._id.slice(0, 6).toUpperCase();
    }
    get isLite() {
        return this.vehicles.some((vehicleType) => vehicleType === legacy_enums_1.VehicleType.SedanLite);
    }
    get areAllPassengersAssigned() {
        return this.passengers.every((passenger) => passenger.assignationId);
    }
    get areSomePassengersAssigned() {
        return this.passengers.some((passenger) => passenger.assignationId);
    }
};
exports.Order = Order;
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "_id", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDCreateDateColumn)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)((value) => new Date(value)),
    __metadata("design:type", Date)
], Order.prototype, "createdAt", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsOptional)({
        groups: [OrderValidationGroup.PriceCalculation],
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "userId", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GInt, { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.OfferType),
    __metadata("design:type", Number)
], Order.prototype, "offerType", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)(
    // So far we support only flexible offers
    // once the same concept of offers is introduced for managed offerings
    // we need to validate offerId in every instance
    (order) => order.offerType === legacy_enums_1.OfferType.Flexible),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "offerId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], Order.prototype, "rideId", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)((value) => new Date(value)),
    __metadata("design:type", Date)
], Order.prototype, "departureAt", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsOptional)({
        groups: [OrderValidationGroup.BookingOrder],
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "routeId", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "originLocationId", void 0);
__decorate([
    (0, graphql_1.GField)(() => Location_1.Location, { nullable: true }),
    __metadata("design:type", Location_1.Location)
], Order.prototype, "originLocation", void 0);
__decorate([
    (0, graphql_1.GField)(() => Location_1.Location, { nullable: true }),
    __metadata("design:type", Location_1.Location)
], Order.prototype, "destinationLocation", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "destinationLocationId", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "pickupAddress", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "dropoffAddress", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(() => [Passenger_1.Passenger]),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsOptional)({
        groups: [OrderValidationGroup.PriceCalculation],
    }),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Passenger_1.Passenger),
    __metadata("design:type", Array)
], Order.prototype, "passengers", void 0);
__decorate([
    (0, graphql_1.GField)(() => [graphql_1.GInt]),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Array)
], Order.prototype, "vehicles", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GInt),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "currency", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "currencyRate", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GInt, { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "pricingCurrency", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.MaxLength)(constants_1.MAX_CUSTOMER_NOTE_LENGTH),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "customerNote", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "managementNote", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "driverNote", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "customQuoteId", void 0);
__decorate([
    (0, graphql_1.GField)(() => [OrderAutomaticEmail_1.OrderAutomaticEmail]),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => value ?? []),
    (0, class_transformer_1.Type)(() => OrderAutomaticEmail_1.OrderAutomaticEmail),
    __metadata("design:type", Array)
], Order.prototype, "automaticEmails", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => RequestHeader_1.RequestHeader),
    __metadata("design:type", RequestHeader_1.RequestHeader)
], Order.prototype, "requestHeader", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GInt),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "paymentMethod", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GInt),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "type", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "tollPrice", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "tollFee", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "additionalPrice", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "additionalFee", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.MaxLength)(18),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "discountCode", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(() => [String]),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => (!value ? [] : value)),
    __metadata("design:type", Array)
], Order.prototype, "discountIds", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.MaxLength)(18),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "referralCode", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "referralCodeId", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)(() => [VehicleTypePriceFee_1.VehicleTypePriceFee], { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => VehicleTypePriceFee_1.VehicleTypePriceFee),
    __metadata("design:type", Array)
], Order.prototype, "vehicleTypesPricesFees", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "totalPrice", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "price", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "fee", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)()
    // this field is applicable for dynamic pricing. we need it here because some orders do not have offer but they have this price adjustment coefficient
    ,
    __metadata("design:type", Number)
], Order.prototype, "priceAdjustmentCoefficient", void 0);
__decorate([
    (0, graphql_1.GAuthorized)(),
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)()
    // this field is applicable for dynamic pricing. we need it here because some orders do not have offer but they have this fee adjustment coefficient
    ,
    __metadata("design:type", Number)
], Order.prototype, "feeAdjustmentCoefficient", void 0);
__decorate([
    (0, graphql_1.GField)(() => [VehicleTypeCoefficient_1.VehicleTypeCoefficient], { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => VehicleTypeCoefficient_1.VehicleTypeCoefficient),
    __metadata("design:type", Array)
], Order.prototype, "vehicleCoefficients", void 0);
__decorate([
    (0, graphql_1.GField)(() => String),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "priceType", void 0);
__decorate([
    (0, graphql_1.GField)(() => [OrderContentLocation_1.OrderContentLocation], { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OrderContentLocation_1.OrderContentLocation),
    __metadata("design:type", Array)
], Order.prototype, "contentLocations", void 0);
__decorate([
    (0, graphql_1.GField)(() => [OrderCustomLocation_1.OrderCustomLocation], { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OrderCustomLocation_1.OrderCustomLocation),
    __metadata("design:type", Array)
], Order.prototype, "customLocations", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)()
    // @IsDate()
    ,
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Order.prototype, "acceptedAt", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)()
    // @IsDate()
    ,
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Order.prototype, "declinedAt", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)()
    // @IsDate()
    ,
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Order.prototype, "confirmedAt", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)()
    // @IsDate()
    ,
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Order.prototype, "cancelledAt", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Order.prototype, "draftedAt", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "createdBy", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "isPickupAddressApproved", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "isDropoffAddressApproved", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "isPickupAddressApprovedAutomatically", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "isDropoffAddressApprovedAutomatically", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GInt, { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => (value == null ? undefined : value)),
    __metadata("design:type", Number)
], Order.prototype, "pickupAddressType", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GInt, { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.AirportTransferDirection),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "airportTransferDirection", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GInt, { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => (value == null ? undefined : value)),
    __metadata("design:type", Number)
], Order.prototype, "dropoffAddressType", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((order) => order.pickupAddressType === legacy_enums_1.LocationAddressType.MeetingPosition),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "meetingPositionId", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((order) => order.dropoffAddressType === legacy_enums_1.LocationAddressType.MeetingPosition),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "dropoffPositionId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "isFeedbackRequestDisabled", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "departureDateChangedLessThan24hUntilDeparture", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "pricingCountryId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "pricingRegionId", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "version", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], Order.prototype, "apiPartnerId", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], Order.prototype, "externalId", void 0);
__decorate([
    (0, graphql_1.GField)(() => Position_1.Position, { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", Object)
], Order.prototype, "pickupPosition", void 0);
__decorate([
    (0, graphql_1.GField)(() => Position_1.Position, { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", Object)
], Order.prototype, "dropoffPosition", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], Order.prototype, "customMarkup", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], Order.prototype, "emailVerificationCode", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], Order.prototype, "isCustomerEmailVerified", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, class_validator_1.IsUUID)("4"),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "partnerId", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "potentialFraud", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "gclid", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "isBusinessTrip", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "hostAgencyId", void 0);
__decorate([
    (0, graphql_1.GField)({ nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "travelAgentId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "tripOptionId", void 0);
__decorate([
    (0, graphql_1.GField)(() => TravelEstimates_1.TravelEstimates, { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", TravelEstimates_1.TravelEstimates)
], Order.prototype, "travelEstimates", void 0);
__decorate([
    (0, graphql_1.GField)(() => AffiliateConversion_1.AffiliateConversion, { nullable: true }),
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", AffiliateConversion_1.AffiliateConversion)
], Order.prototype, "affiliateConversion", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "isVIP", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", DynamicPricingInputs_1.DynamicPricingInputs)
], Order.prototype, "dynamicPricing", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Order.prototype, "cancellationInfo", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OrderCommission_1.OrderCommission),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", OrderCommission_1.OrderCommission)
], Order.prototype, "commission", void 0);
exports.Order = Order = Order_1 = __decorate([
    (0, graphql_1.GObjectType)("Order"),
    (0, graphql_1.GInputType)("OrderInput"),
    (0, orm_1.CDEntity)("orders")
], Order);
function getChildSeatsForOrder(order) {
    const childSeats = [];
    order.passengers.forEach(({ childSeatType }) => {
        if ((0, utils_1.isUndefinedOrNull)(childSeatType)) {
            return;
        }
        childSeats.push(childSeatType);
    });
    return childSeats;
}
exports.getChildSeatsForOrder = getChildSeatsForOrder;
function isAirportTransfer(order) {
    return [legacy_enums_1.AirportTransferDirection.FromAirport, legacy_enums_1.AirportTransferDirection.ToAirport].includes(order.airportTransferDirection ?? legacy_enums_1.AirportTransferDirection.None);
}
exports.isAirportTransfer = isAirportTransfer;
//# sourceMappingURL=Order.js.map